;import Vue from 'vue'
import Vuex from 'vuex'
import {STORE_USER_INFO,LOCAL_USER_INFO,TOKEN_ID,LOCAL_ROLE_ID} from '@/mutation/mutConst'
Vue.use(Vuex);
export default new Vuex.Store({
	state : {
        storeUserInfo : '',
        tokenId : '',
        localRoleId :''
    },
	mutations: {
        [STORE_USER_INFO](state,data){
         state.storeUserInfo = data;
           // 存到storege中
           localStorage.setItem(LOCAL_USER_INFO, JSON.stringify(data));
        },
        [TOKEN_ID] (state,data) {
    
            state.tokenId = data
            localStorage.setItem(TOKEN_ID,data);
        },
        [LOCAL_ROLE_ID] (state,data) {
    
            state.localRoleId = data
            localStorage.setItem(LOCAL_ROLE_ID,data);
        }
    },
    actions : {
        
    }
})



// WEBPACK FOOTER //
// ./src/mutation/index.js